import React from 'react';
import { spotifyPlaylists } from '../data/mockData';
import { Music } from 'lucide-react';

const SpotifyPage = () => {
  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          SPOTIFY PLAYLIST
        </h1>
        <div className="w-20 h-1 mx-auto mb-4" style={{ backgroundColor: 'var(--tp-red)' }} />
        <p className="text-center text-gray-400 mb-8 sm:mb-12 max-w-xl mx-auto text-sm sm:text-base">
          Ascolta le migliori playlist curate da Tecniche Perfette. Dalle battle freestyle ai beat per le tue sessioni.
        </p>

        {/* Playlist Grid - Full Width Players */}
        <div className="space-y-6">
          {spotifyPlaylists.map((playlist) => (
            <div key={playlist.id} className="w-full">
              <iframe
                src={playlist.embedUrl}
                width="100%"
                height="380"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title={playlist.title}
                className="rounded-lg"
              />
            </div>
          ))}
        </div>

        {/* Spotify Follow CTA */}
        <div className="mt-12 text-center p-8 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <Music size={40} className="text-green-500 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
            SEGUICI SU SPOTIFY
          </h3>
          <p className="text-gray-400 mb-6 max-w-md mx-auto">
            Non perderti le nostre playlist aggiornate con i migliori freestyle e le ultime produzioni.
          </p>
          <a href="https://open.spotify.com/intl-it/artist/3REyzEwrDBJCnhmfLvpZUj" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-green-600 hover:bg-green-700 text-white font-bold transition-colors"
            style={{ fontFamily: 'Oswald, sans-serif' }}>
            <Music size={18} /> SEGUI TECNICHE PERFETTE
          </a>
        </div>
      </div>
    </div>
  );
};

export default SpotifyPage;
